module.exports = __webpack_public_path__ + "static/media/screenshot-leaderboard2x.e9408a84.png";